import {Navigate, Route} from "react-router-dom";
import * as React from "react";
import {UserAuthItemTypeEnum} from "arteco-api-client-ts";
import {Book, Dns, HowToReg, NoteAlt, Psychology} from "@mui/icons-material";
import {AdminLayout} from "./pages/admin/layout";
import {ConfigPage} from "./pages/admin/config";
import {ParamListPage} from "./pages/admin/config/param";
import {ParamEditPage} from "./pages/admin/config/param/form";
import {UserListPage} from "./pages/admin/config/user";
import {UserEditPage} from "./pages/admin/config/user/form";
import {AiConfigPage} from "./pages/admin/config/ai_config";
import {TemplateListPage} from "./pages/admin/config/template";
import {TemplateEditPage} from "./pages/admin/config/template/form";
import {WikiPageListPage} from "./pages/admin/employee/wiki";
import {SECTION_SYSTEM, WikiPageEditPage} from "./pages/admin/employee/wiki/form";
import SideBarItem from "./sidebar_item";
import {useAuthManager} from "./components/utils/auth";

/**
 * Configuración de la Extranet: parámetros, usuarios y permisos, IA, plantillas y wiki del sistema.
 * Era el SUPERADMIN de cuando la Extranet era multiempresa y la «empresa» del ADMIN; con una sola
 * empresa es una sección, solo para ADMIN (#13722).
 */
const ConfigGuard = ({children}: { children: React.ReactNode }) => {
	const authManager = useAuthManager();
	const isAdmin = authManager.getAuthorities().some(a => a.type === UserAuthItemTypeEnum.ADMIN);
	if (!isAdmin) {
		return <Navigate to="/app" replace/>;
	}
	return <>{children}</>;
};

const BASE = "/app/admin/config";

const ConfigRoutes = () => {
	return (
		<>
			<Route path={BASE} element={<AdminLayout/>}>
				<Route index element={<ConfigGuard><ConfigPage/></ConfigGuard>}/>
				<Route path={`${BASE}/param`} element={<ConfigGuard><ParamListPage/></ConfigGuard>}/>
				<Route path={`${BASE}/param/:id`} element={<ConfigGuard><ParamEditPage/></ConfigGuard>}/>
				<Route path={`${BASE}/param/new`} element={<ConfigGuard><ParamEditPage/></ConfigGuard>}/>
				<Route path={`${BASE}/user`} element={<ConfigGuard><UserListPage/></ConfigGuard>}/>
				<Route path={`${BASE}/user/:id`} element={<ConfigGuard><UserEditPage/></ConfigGuard>}/>
				<Route path={`${BASE}/user/new`} element={<ConfigGuard><UserEditPage/></ConfigGuard>}/>
				<Route path={`${BASE}/ai-config`} element={<ConfigGuard><AiConfigPage/></ConfigGuard>}/>
				<Route path={`${BASE}/template`} element={<ConfigGuard><TemplateListPage/></ConfigGuard>}/>
				<Route path={`${BASE}/template/:id`} element={<ConfigGuard><TemplateEditPage/></ConfigGuard>}/>
				<Route path={`${BASE}/template/new`} element={<ConfigGuard><TemplateEditPage/></ConfigGuard>}/>
				<Route path={`${BASE}/wiki`} element={<ConfigGuard><WikiPageListPage section={SECTION_SYSTEM}/></ConfigGuard>}/>
				<Route path={`${BASE}/wiki/:id`} element={<ConfigGuard><WikiPageEditPage section={SECTION_SYSTEM}/></ConfigGuard>}/>
				<Route path={`${BASE}/wiki/new`} element={<ConfigGuard><WikiPageEditPage section={SECTION_SYSTEM}/></ConfigGuard>}/>
			</Route>
			{/* Enlaces guardados de las dos secciones antiguas */}
			<Route path="/app/admin/super/*" element={<Navigate to={BASE} replace/>}/>
			<Route path="/app/admin/company/*" element={<Navigate to={BASE} replace/>}/>
			{/* El sistema de gestión se fue a su módulo (#13899): route_admin_compliance.tsx redirige */}
		</>
	);
}

export default ConfigRoutes;

export const ConfigMenu = () => {
	return (
		<>
			<SideBarItem href={`${BASE}/param`} label={"Parámetros"} icon={<Dns/>}/>
			<SideBarItem href={`${BASE}/user`} label={"Usuarios y permisos"} icon={<HowToReg/>}/>
			<SideBarItem href={`${BASE}/ai-config`} label={"Inteligencia artificial"} icon={<Psychology/>}/>
			<SideBarItem href={`${BASE}/template`} label={"Plantillas"} icon={<Book/>}/>
			<SideBarItem href={`${BASE}/wiki`} label={"Wiki del sistema"} icon={<NoteAlt/>}/>
		</>
	)
}
